import { render, staticRenderFns } from "./Blackbar.vue?vue&type=template&id=28fd84d0&"
import script from "./Blackbar.vue?vue&type=script&lang=js&"
export * from "./Blackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports